import { createContext } from "react";

import type { WorkspaceRepositoryController } from "./WorkspaceRepository.controller.types";

/** Kept in its own module so Vite HMR does not replace the context instance. */
export const WorkspaceRepositoryContext =
  createContext<WorkspaceRepositoryController | null>(null);
